// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__2jbcu","imageUploader":"EGiftCard_imageUploader__10HbQ"};